export default __webpack_public_path__ + "static/media/gallery_09.ae43c7ae.jpg";